import React, { useState, useEffect } from 'react'
import HeroBlock from '../blocks/HeroBlock'
import Layout from '../modules/Layout'
import ArticleTripleTeaserBlock from '../blocks/ArticleTripleTeaserBlock'
import { Listbox } from '@headlessui/react'
import { Link } from 'gatsby'

import { useTranslation } from 'react-i18next'
import SEO from '../modules/Seo'
import DealerSearchBlock from '../blocks/DealerSearchBlock'

// TODO: Dropdown fixen + Woher kommt content.collection für teaser?

const ArticleIndexPage = ({
  content,
  locale,
  full_slug,
  name,
  alternates,
  childs,
}) => {
  const { t } = useTranslation()

  const [linkCollection, setLinkCollection] = useState([])

  useEffect(() => {
    setLinkCollection(t('article_index_page.link_collection'))
  }, [locale])

  return (
    <div>
      <Layout locale={locale} alternates={alternates}>
        <SEO content={content} name={name} og_locale={locale} />
        <HeroBlock
          block={{
            hero_mirrored: content.hero_mirrored,
            headline: content.headline?.length > 0 ? content.headline : name,
            image: content.header_image,
            hero_variant_class: 'kn-product-hero',
          }}
        />
        <section className="header-block product-overview">
          <div className="header-block-content item-grid-block-header-filter">
            <div className="dropdown">
              <Listbox>
                <Listbox.Button className="btn btn-outline-secondary dropdown-toggle">
                  {linkCollection.map(
                    (item) => item.link === full_slug && item.title
                  )}
                </Listbox.Button>
                <Listbox.Options className="dropdown-menu show">
                  {linkCollection.map((item, index) => (
                    <Listbox.Option key={index}>
                      <Link className="dropdown-item" to={`/${item.link}`}>
                        {item.title}
                      </Link>
                    </Listbox.Option>
                  ))}
                </Listbox.Options>
              </Listbox>
            </div>
          </div>
        </section>

        <ArticleTripleTeaserBlock block={{}} data_source={childs} />
        <DealerSearchBlock block={{}} />
      </Layout>
    </div>
  )
}

export default ArticleIndexPage
